<div class="hero-section">
  <div class="hero-content">
    <h1>
      <span class="highlight-blue">GCSE</span> Focused Classes & 
      <span class="highlight-black">Exam</span> Preparation
    </h1>

    <p class="subheading">
      <a href="#">AQA</a> | <a href="#">OCR</a> | <a href="#">EDEXCEL</a> | <a href="#">EDUQAS</a> 
      <span class="classes">ONLINE 1-2-1 & GROUP CLASSES</span>
    </p>

    <div class="hero-image">
      <img src="assets/images/Gcseimg1.png" alt="Students in class">
    </div>

    <div class="cta-buttons">
 <button class="btn1 btn-blue" routerLink="/freedemo">Book a Free Demo</button>

      <a routerLink="/gcse-mock-test" class="btn1 btn-yellow">Browse Mock Tests</a>
    </div>
  </div>

 <h2 class="testimonial-heading">
  Happy <span class="underline">Parents & Successful Students at</span> SEHYOG
</h2>

  <div class="youtube-videos">
           <iframe src="https://www.youtube.com/embed/fVU0xDgiclA" title="Happy Parents Speak: Success Stories &amp; Testimonials 02" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
   
       <iframe  src="https://www.youtube.com/embed/bSFVlZahTac?si=ObniW_umo9GaPPzt"
         title="Happy Parents Speak: Success Stories &amp; Testimonials 01" frameborder="0"
         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
         referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
             
         <iframe  src="https://www.youtube.com/embed/n1OKFV6Wa68?si=u-3smcQJEFD7XJD0"
      title="Happy Parents Speak: Success Stories &amp; Testimonials 01" frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
  </div>

  <div class="success-strip">
    <p>Over 10K+ Successful GCSE Students</p>
<button class="btn2 btn-blue" routerLink="/freedemo">Book a Free Demo</button>
  </div>
</div>


    <!-- Strategy section -->
<div class="strategy-section">

  <!-- LEFT: Heading + copy -->
  <div class="strategy-left">
    <h2 class="heading">SEHYOG Strategy</h2>
    <p>Comprehensive Offerings Under<br>One Umbrella</p>
  </div>

  <!-- RIGHT: Top row of 2 cards -->
  <div class="strategy-right">
    <div class="top-row">
      <!-- Card 1 -->
      <div class="flip-card">
        <div class="flip-card-inner">
          <div class="flip-card-front">
            <img src="assets/images/strategy1.png" alt="Targeted Study Notes">
            <div class="card-title">Targeted Study Notes</div>
          </div>
          <div class="flip-card-back">
            <h3>Targeted Study Notes</h3>
            <ul>
              <li>Board-wise experienced teachers</li>
              <li>Activate prior learning</li>
              <li>Concept depth + summaries</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Card 2 -->
      <div class="flip-card">
        <div class="flip-card-inner">
          <div class="flip-card-front">
            <img src="assets/images/startegy2.png" alt="Interactive Lectures">
            <div class="card-title">Interactive Lectures</div>
          </div>
          <div class="flip-card-back">
            <h3>Interactive Lectures</h3>
            <ul>
              <li>Live doubt-solving</li>
              <li>Engaging explanations</li>
              <li>Practice-led sessions</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- BOTTOM: 5 cards span full width -->
  <div class="bottom-row">
    <!-- Card 3 -->
    <div class="flip-card">
      <div class="flip-card-inner">
        <div class="flip-card-front">
          <img src="assets/images/stategy3.png" alt="All Round Learning">
          <div class="card-title">All Round Learning</div>
        </div>
        <div class="flip-card-back">
          <h3>All Round Learning</h3>
          <ul>
            <li>Concepts + application</li>
            <li>Balanced coverage</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Card 4 -->
    <div class="flip-card">
      <div class="flip-card-inner">
        <div class="flip-card-front">
          <img src="assets/images/strategy4.png" alt="Consistent Assessment">
          <div class="card-title">Consistent Assessment</div>
        </div>
        <div class="flip-card-back">
          <h3>Consistent Assessment</h3>
          <ul>
            <li>Regular tests</li>
            <li>Progress tracking</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Card 5 -->
    <div class="flip-card">
      <div class="flip-card-inner">
        <div class="flip-card-front">
          <img src="assets/images/startegy5.png" alt="Error Log & Feedback">
          <div class="card-title">Error Log & Feedback</div>
        </div>
        <div class="flip-card-back">
          <h3>Error Log & Feedback</h3>
          <ul>
            <li>Personalized feedback</li>
            <li>Actionable insights</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Card 6 -->
    <div class="flip-card">
      <div class="flip-card-inner">
        <div class="flip-card-front">
          <img src="assets/images/startegy6.png" alt="Past Papers & Mocks">
          <div class="card-title">Past Papers & Full Mocks</div>
        </div>
        <div class="flip-card-back">
          <h3>Past Papers & Mocks</h3>
          <ul>
            <li>Exam-style practice</li>
            <li>Time management</li>
          </ul>
        </div>
      </div>
    </div>

    
    <!-- Card 7 -->
    <div class="flip-card">
      <div class="flip-card-inner">
        <div class="flip-card-front">
          <img src="assets/images/startegy6.png" alt="Analytics Dashboard">
          <div class="card-title">Analytics Dashboard</div>
        </div>
        <div class="flip-card-back">
          <h3>Analytics Dashboard</h3>
          <ul>
            <li>Strengths & gaps</li>
            <li>Smart recommendations</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</div>
<!-- Strategy Section Ends Here -->


<!-- Course and Subjects  -->

<div class="spacer"></div>

<div class="subjects">

<h1>Courses & Subjects We Offer</h1>


  <ul class="subject-list u">
    <li>Mathematics</li>
    <li>English </li>
    <li>Physics</li>
    <li>Chemistry</li>
    <li>Biology</li>
    <li>German</li>
    <li>French</li>
  </ul>

  <div class="spacer"></div>
  <!-- Courses -->

  <div class="course-container">
        <!-- Fast Forward Course Card -->
        <div class="course-card">
            <div class="card-header orange-gradient">
                <div class="card-name">
                    Fast Forward Course <span class="title-icon">▶▶</span>
                </div>
                <div class="card-subtitle">
                  Fast forward Course for Year 11, Year 10, Year 9, Year 8 & Year 7 Students
                </div>
            </div>
            
            <div class="card-content">
                <div class="info-section">
                    <div class="section-label">RECOMMENDED FOR:</div>
                    <div class="section-text">Year 11, 10, 9, 8 & 7</div>
                </div>
                
                <div class="info-section">
                    <div class="section-label">DURATION:</div>
                    <div class="section-text">35-45 Weeks</div>
                </div>
                
                <div class="info-section">
                    <div class="section-label">SESSIONS:</div>
                    <div class="section-text"> 175-230 Sessions</div>
                </div>
                
                <div class="info-section">
                    <div class="section-label">PROVIDED:</div>
                    <ul class="feature-list">
                        <li>Course Structure & Pre-Lecture Material (PLM),</li>
                        <li>Daily / Weekly Home / Class</li>
                        <li>Face to Face Unit, Topic Tests,</li>
                        <li>Fortnightly Revision Tests,</li>
                        <li>Weekly Doubt Clearing Sessions</li>
                    </ul>
                </div>
                
                <div class="info-section">
                    <div class="section-label">FEE SCHEDULE:</div>
                    <div class="section-text">Advance One Time Payment / Monthly Payment</div>
                </div>
                
                <button class="demo-btn" routerLink="/freedemo">Book a Free Demo</button>
            </div>
        </div>
        
        <!-- Regular Course Card -->
        <div class="course-card">
            <div class="card-header orange-gradient">
                <div class="card-name">
                    Regular Course <span style="font-size: 14px; font-weight: normal;">(Pay As You Go)</span>
                </div>
                <div class="card-subtitle">
                   Basics to best level GCSE preparation for Year 8, Year 7 Year 9, Year 10 & Year 11 Students
                </div>
            </div>
            
            <div class="card-content">
                <div class="info-section">
                    <div class="section-label">RECOMMENDED FOR:</div>
                    <div class="section-text">Year 5, 4 & 3 students</div>
                </div>
                
                <div class="info-section">
                    <div class="section-label">DURATION:</div>
                    <div class="section-text">Flexible</div>
                </div>
                
                <div class="info-section">
                    <div class="section-label">SESSIONS:</div>
                    <div class="section-text">Flexible</div>
                </div>
                
                <div class="info-section">
                    <div class="section-label">PROVIDED:</div>
                    <ul class="feature-list">
                        <li>Course Structure & Pre-Lecture Material (PLM),</li>
                        <li>Daily / Weekly Home / Class</li>
                        <li>Face to Face Unit, Topic Tests,</li>
                        <li>Revision Tests,</li>
                        <li>Doubt Clearing Sessions</li>
                    </ul>
                </div>
                
                <div class="info-section">
                    <div class="section-label">FEE SCHEDULE:</div>
                    <div class="section-text">Monthly Payment</div>
                </div>
                
                <button class="demo-btn" routerLink="/freedemo">Book a Free Demo</button>
            </div>
        </div>



</div>

<div class="spacer"></div>

<!-- RAR -->

<div class="rar">

  <h1>Result Analysis Report</h1>

  <h3>Designed to provide Detailed Insights into your Child's Test Performance.</h3>

  <img src="assets/images/ep-rar2.png" alt="">

</div>



 <!-- section 6 starts here -->

  <div class="section-6">
    <h1>Offline Activities</h1>

    <div class="gallery-container">
      <div class="gal-left">
        <img
          [src]="currentImage"
          alt="Event Image"
          class="large-image"
          [class.zoom]="isSliding"
        />
      </div>

      <div class="gal-right">
        <h1 class="img-title">{{ currentTitle }}</h1>

        <!-- <div class="btn-div">
         <button class="gal-btn" [routerLink]="['/sehyog/photo-gallery']">View Photos</button>
         <button class="gal-btn sd" [routerLink]="['/sehyog/video-gallery']">View Videos</button>
        </div> -->

        <div class="spacer"></div>
        <div class="spacer"></div>
        <div class="spacer"></div>

        <div class="gal-thumb">
          <img
            *ngFor="let img of gal_images; let i = index"
            [src]="img.src"
            (click)="changeImage(i)"
            [class.active]="i === currentIndex"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- section 6 ends here -->


  <!-- Microsoft Clarity -->
<script type="text/javascript">
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/XXXX";
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "XXXX");
</script>